<div id="content" class="allcp-form without-subnavbar" ng-controller="SupportController">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <div class="panel-body" ng-class="{'flex-center': support.success}">
        <div class="col-md-6 p-0" ng-if="!support.success">
            <form ng-submit="save()" class="form-horizontal row allcp-form">
                <div class="col-md-12">
                    <div class="form-group floating">
                        <select name="priorty" ng-model="support.priorty" class="form-control ">
                            <option value="Low">Low</option>
                            <option value="Middle">Middle</option>
                            <option value="High">High</option>
                        </select>
                        <label>
                            Priorty
                        </label>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group floating">
                        <input type="text" ng-model="support.title" class="form-control " placeholder="Subject" required>
                        <label>Subject</label>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group floating">
                        <textarea name="body" id="" cols="30" rows="10" ng-model="support.body" class="form-control " placeholder="Details" required style="height: 300px"></textarea>
                        <label>
                            Details
                        </label>
                    </div>
                </div>
                <div class="col-md-12">
                    <button type="submit" class="btn btn-primary">Send</button>
                </div>
            </form>
        </div>
        <div class="success-box" ng-if="support.success">
            <img src="/img/sucess-icon.svg">
            <h3>
                Your feedback successfully sent.
            </h3>
            <a href="#" class="btn" ng-click="showForm()">
                Send Another Feedback
            </a>
        </div>
    </div>
</div>
